import PropTypes from 'prop-types';
import { Component } from 'react';

export default class EntitlementsWrapper extends Component {
  static propTypes = {
    entitlement: PropTypes.string.isRequired,
    entitlementValue: PropTypes.any,
    predicate: PropTypes.func,
    children: PropTypes.any
  };

  render() {
    const { entitlementValue, predicate = Boolean, children } = this.props;
    return predicate(entitlementValue) ? children : null;
  }
}
